import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * The Color Swatch component renders a supplied label next to a generated element with a given color.
 *
 */
function ColorSwatch(_ref) {
  let {
    colorValue,
    label,
    className,
    ...rest
  } = _ref;
  let swatchColor = colorValue?.toLowerCase().replace(/\s/g, '');
  switch (colorValue?.toLowerCase()) {
    case 'burgundy':
      swatchColor = '#800020';
      break;
    case 'offwhite':
      swatchColor = '#f9f9f9';
      break;
    case 'charcoal':
      swatchColor = '#333333';
      break;
    default:
  }
  const shouldHaveContrast = color => {
    const colorValues = ['white', 'offwhite', 'beige', '#f9f9f9', '#fffff', 'rgb(0,0,0)', 'rgb(249,249,249)'];
    return colorValues.includes(color);
  };
  const swatchClassName = clsx({
    swatch: true,
    unavailable: !colorValue,
    contrast: shouldHaveContrast(swatchColor)
  });
  const containerClassName = clsx({
    'color-swatch': true
  }, className);
  const swatchColorStyle = swatchColor ? {
    backgroundColor: swatchColor
  } : undefined;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "colorSwatch"
  }, rest, {
    className: containerClassName
  }), /*#__PURE__*/_jsx("div", {
    className: swatchClassName,
    style: swatchColorStyle
  }, void 0, "\xA0"), label);
}
export default ColorSwatch;